module.exports = __webpack_public_path__ + "static/media/Clear.4f31ae01.jpg";